import React, { useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import { FaRegCircleCheck } from "react-icons/fa6";
import TermsAndConditionScreen from './InitialT&C';

const InitialScreen = ({ onOkClick }) => {
  const [isTermsAndConditions, setIsTermsAndConditions] = useState(false);

  const imageUrl = localStorage.getItem('tcpage_img');
  const show_tcpage = JSON.parse(localStorage.getItem("show_tcpage"));

  return (
    !isTermsAndConditions  && show_tcpage == "1" ? (
      <Box className="mt-6 text-center" sx={{
        position: "relative"
      }}>
        <img src={imageUrl} alt="" width={"100%"} height={"auto"} style={{ backgroundColor: "transparent", color: "transparent"}}/>
        <Button
          size="small"
          variant="contained"
          disableRippl
          onClick={onOkClick}
          sx={{
            marginTop: "20px",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingRight: "50px",
            paddingLeft: "50px",
            borderTopLeftRadius: "10px",
            borderBottomLeftRadius: "10px",
            borderTopRightRadius: "10px",
            borderBottomRightRadius: "10px",
            backgroundColor: "#facc15",
            color: "black",
            fontWeight: "600",
            "&:hover": {
              backgroundColor: "#eab308",
              borderColor: "#eab308",
              boxShadow: "none",
            },
            "&:active": {
              boxShadow: "none",
              backgroundColor: "#facc15",
              borderColor: "#ca8a04",
            },
          }}
        >
          အသုံးပြုမည်
        </Button>
        <Typography
          variant="body2"
          lang="my"
          style={{ fontSize: "0.7rem", marginTop: "30px" }}
          className="flex justify-center items-center py-4"
        >
          <FaRegCircleCheck
            color="#FFF"
            style={{ fontSize: "1rem" }}
            className="mr-1"
          />
           <span
              style={{ textDecoration: "underline", cursor: "pointer" }}
              onClick={() => setIsTermsAndConditions(true)}
            >
              စည်းမျဥ်းစည်းကမ်းများ
            </span>အား နားလည်သဘောတူပါသည်။
        </Typography>
      </Box>
    ) : <TermsAndConditionScreen setIsTermsAndConditions={setIsTermsAndConditions} />
  );
};

export default InitialScreen;
